"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _db = _interopRequireDefault(require("../db.json"));

var _main = _interopRequireDefault(require("../templates/main"));

var _userAgent = _interopRequireDefault(require("../../../common/userAgent.0.0.3"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formatter = _interopRequireDefault(require("../../../utils/formatter"));

var _IPhone = _interopRequireDefault(require("../../../common/iObjects/IPhone"));

var _escapeRegExp = _interopRequireDefault(require("../../../utils/escapeRegExp"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var _react = _interopRequireDefault(require("react"));

var _cursorPosition = _interopRequireDefault(require("../../../utils/cursorPosition"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getCollectionsByCountries", function (countries) {
      var collection = _this._getCollection(countries),
          _this$_getDigitsCodes = _this._getDigitsCodes(collection),
          threeDigitsCode = _this$_getDigitsCodes.threeDigitsCode,
          twoDigitsCode = _this$_getDigitsCodes.twoDigitsCode,
          oneDigitsCode = _this$_getDigitsCodes.oneDigitsCode;

      _this._threeDigitsCode = threeDigitsCode;
      _this._twoDigitsCode = twoDigitsCode;
      _this._oneDigitsCode = oneDigitsCode;
      return collection;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getDigitsCodes", function () {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.collection;
      return {
        threeDigitsCode: collection.filter(function (item) {
          return item.dialCode && item.dialCode.length === 4;
        }),
        twoDigitsCode: collection.filter(function (item) {
          return item.dialCode && item.dialCode.length === 3;
        }),
        oneDigitsCode: collection.filter(function (item) {
          return item.dialCode && item.dialCode.length === 2;
        })
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getCollection", function () {
      var countries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.countries;
      return countries && countries.length ? _db["default"].filter(function (model) {
        return countries.includes(model.internationalCountryName);
      }) : _db["default"];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleChangeCode",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(event) {
        var country;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                country = _this.state.collection.find(function (item) {
                  return item.id === event.target.value;
                });
                _this.value = {
                  code: country ? country.id : null,
                  dialCode: country ? country.dialCode : null
                };

                _this.focus();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleChangeNumber",
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(event) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.updateCarriage(event);

                _this.changed = true;
                _this.value = {
                  number: _this._prepareNumber(event.target.value, _this.state.code)
                };

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handlePaste",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3() {
      var event,
          value,
          nextValue,
          parsed,
          _args3 = arguments;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              event.preventDefault();
              value = event.clipboardData.getData('text/plain').trim();

              if (value.startsWith('+')) {
                parsed = _this._parseValue(value);
                nextValue = _objectSpread({}, parsed, {
                  number: _this._prepareNumber(parsed.number, parsed.code)
                });
              } else {
                nextValue = {
                  number: _this._prepareNumber(value, _this.state.code)
                };
              }

              _this.value = nextValue;

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_prepareNumber", function (value, code) {
      return _this._numberFormat(value, code).replace(/\s/g, '');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFocus",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee4() {
      var event,
          _args4 = arguments;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _context4.next = 3;
              return _this.setState({
                focus: true
              });

            case 3:
              if (typeof _this.props.onFocus === 'function') {
                _this.props.onFocus(event);
              }

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBlur",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee5() {
      var event,
          _args5 = arguments;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              event = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
              _context5.next = 3;
              return _this.setState({
                focus: false
              });

            case 3:
              if (typeof _this.props.onBlur === 'function') {
                _this.props.onBlur(event);
              }

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_codeSearchFunc", function () {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      query = new RegExp((0, _escapeRegExp["default"])(query), 'i');

      var result = _this.state.collection.filter(function (model) {
        return query.test(model.dialCode) || query.test(model.name.ua) || query.test(model.name.ru) || query.test(model.name.en);
      });

      return list.filter(function (item) {
        return result.some(function (country) {
          return country.id === item.id;
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (el) {
      return _this.input.current = el;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleHover", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRootBlur", function () {
      return _this.setState({
        hover: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_externalRef", function (el) {
      var elementRef = _this.props.elementRef;

      if (typeof elementRef === 'function') {
        elementRef(el);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = el;
      }
    });
    _this.state = {
      focus: false,
      hover: false,
      collection: _this._getCollectionsByCountries()
    };
    _this.state = _objectSpread({}, _this.state, {}, _this._parseValue(props.value));
    _this.root = _react["default"].createRef();
    _this.input = _react["default"].createRef();

    var _register = (0, _cursorPosition["default"])(_this.input, /\d/),
        _register2 = (0, _slicedToArray2["default"])(_register, 2),
        update = _register2[0],
        set = _register2[1];

    _this.updateCarriage = update;
    _this.restoreCarriage = set;
    _this.changed = false;
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // initial value was changed due to parsing rules
      if (this.value !== this.props.value) {
        this._dispatchSyntheticEvent();
      }

      if (typeof this.props.elementRef === 'function') {
        this._externalRef(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Main.prototype), "componentWillUnmount", this).call(this);

      this._externalRef(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee6(prevProps) {
        var _this$props, value, countries;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$props = this.props, value = _this$props.value, countries = _this$props.countries;

                if (this.changed) {
                  this.restoreCarriage(this._numberFormat(this.state.number, this.state.code));
                  this.changed = false;
                }

                if (!(value !== prevProps.value)) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 5;
                return this.setState(_objectSpread({}, this._parseValue(value)));

              case 5:
                // new value was changed due to parsing rules
                if (this.value !== value) {
                  this._dispatchSyntheticEvent();
                }

              case 6:
                if (countries !== prevProps.countries) {
                  this.setState({
                    collection: this._getCollectionsByCountries()
                  });
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function componentDidUpdate(_x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "_dispatchSyntheticEvent",
    value: function _dispatchSyntheticEvent() {
      var target = {
        value: this.value,
        name: this.props.name,
        type: 'input'
      },
          _this$state = this.state,
          code = _this$state.code,
          number = _this$state.number,
          dialCode = _this$state.dialCode;

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target), {
          code: code,
          number: number,
          dialCode: dialCode
        });
      }
    }
  }, {
    key: "_numberFormat",
    value: function _numberFormat() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var code = arguments.length > 1 ? arguments[1] : undefined;

      // В Android-браузере проблемы со сменой клавиатуры при вводе форматированного текста
      if (!_userAgent["default"].os.isAndroid) {
        if (code === 'UA+380') {
          value = (0, _formatter["default"])(value, '{{dd}} {{ddd}} {{dd}} {{dd}}');
        } else if (code === 'RU+7') {
          value = (0, _formatter["default"])(value, '{{ddd}} {{ddd}} {{ddd}} {{ddd}}');
        } else {
          value = (0, _formatter["default"])(value, '{{ddd}} {{ddd}} {{ddd}} {{ddd}}');
        }
      }

      return value;
    }
  }, {
    key: "_parseValue",
    value: function _parseValue() {
      var _this2 = this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var country, number;

      if (value instanceof _IPhone["default"]) {
        value = value.toString();
      }

      if (value && value[0] === '+') {
        var phoneCode = value.substr(0, 4);
        country = this._threeDigitsCode.filter(function (item) {
          return item.dialCode === phoneCode;
        });

        if (!country.length) {
          phoneCode = value.substr(0, 3);
          country = this._twoDigitsCode.filter(function (item) {
            return item.dialCode === phoneCode;
          });
        }

        if (!country.length) {
          phoneCode = value.substr(0, 2);
          country = this._oneDigitsCode.filter(function (item) {
            return item.dialCode === phoneCode;
          });
        }

        if (!country.length) {
          var defaultCountry = this.state.collection.find(function (model) {
            return model.id === 'UA+380';
          });

          if (defaultCountry) {
            country = [defaultCountry];
          } else {
            country = [this.state.collection[0]];
          }
        } // один телефонный код может соответствовать разным странам
        // если в селекте уже выбран код одной из таких стран, не нужно его перетирать


        if (country.length && country.length > 1 && this.state.code) {
          var match = country.filter(function (item) {
            return item.id === _this2.state.code;
          });
          country = match && match.length ? match[0] : country[0];
        } else {
          country = country[0];
        }

        if (value.startsWith(country.dialCode)) {
          number = value.replace(country.dialCode, '');
        }
      } else {
        country = this.state.collection.find(function (model) {
          return model.id === 'UA+380';
        }) || this.state.collection[0];
        number = value;
      }

      number = typeof number === 'string' ? number.replace(/[\D]+/g, '') : number;
      return {
        code: country.id,
        dialCode: country.dialCode,
        number: number
      };
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$input$current;

      (_this$input$current = this.input.current) === null || _this$input$current === void 0 ? void 0 : _this$input$current.focus();
    }
  }, {
    key: "value",
    get: function get() {
      var _this$state2 = this.state,
          _this$state2$dialCode = _this$state2.dialCode,
          dialCode = _this$state2$dialCode === void 0 ? '' : _this$state2$dialCode,
          _this$state2$number = _this$state2.number,
          number = _this$state2$number === void 0 ? '' : _this$state2$number;
      return dialCode + number;
    },
    set: function set(_ref6) {
      var _this3 = this;

      var _ref6$code = _ref6.code,
          code = _ref6$code === void 0 ? this.state.code : _ref6$code,
          _ref6$number = _ref6.number,
          number = _ref6$number === void 0 ? this.state.number : _ref6$number,
          _ref6$dialCode = _ref6.dialCode,
          dialCode = _ref6$dialCode === void 0 ? this.state.dialCode : _ref6$dialCode;
      return this.setState({
        code: code,
        number: number,
        dialCode: dialCode
      }).then(function () {
        _this3._dispatchSyntheticEvent();
      });
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  lang: 'ua',
  maxLength: 6
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  countries: _propTypes["default"].array,
  lang: _propTypes["default"].oneOf(['ua', 'en', 'ru', 'uk']),
  maxLength: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     * @description only for calculation of default divider height
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.transitionFunction
     */
    labelTransitionFunction: _propTypes["default"].string,

    /**
     * @default palette.transitionDuration
     */
    labelTransitionDuration: _propTypes["default"].string,

    /**
     * @default 0
     */
    labelPaddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    labelPaddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default visible
     */
    labelOverflow: _propTypes["default"].string,

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    idleLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    idleBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    idleBorderStyle: _propTypes["default"].string,

    /**
     * @default scale(0)
     */
    idleBorderTransform: _propTypes["default"].string,

    /**
     * @default 1px
     */
    idleBorderWidth: _propTypes["default"].string,

    /**
     * @default 0
     */
    idleBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    idleBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    idleBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    focusLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    focusBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    focusBorderStyle: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    focusBorderTransform: _propTypes["default"].string,

    /**
     * @default 2px
     */
    focusBorderWidth: _propTypes["default"].string,

    /**
     * @default 0
     */
    focusBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    focusBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    hoverLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elSecondary
     */
    hoverBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    hoverBorderStyle: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    hoverBorderTransform: _propTypes["default"].string,

    /**
     * @default 2px
     */
    hoverBorderWidth: _propTypes["default"].string,

    /**
     * @default 0
     */
    hoverBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    disabledLabelColor: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    disabledBorderTransform: _propTypes["default"].string,

    /**
     * @default none none dotted
     */
    disabledBorderStyle: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    disabledBorderColor: _propTypes["default"].string,

    /**
     * @default 2px
     */
    disabledBorderWidth: _propTypes["default"].string,

    /**
     * @default 0
     */
    disabledBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    disabledBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    disabledBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elError
     */
    errorBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    errorBorderStyle: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    errorBorderTransform: _propTypes["default"].string,

    /**
     * @default 2px
     */
    errorBorderWidth: _propTypes["default"].string,

    /**
     * @default 0
     */
    errorBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    errorBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    errorBoxShadow: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Phone');
var _default = Main;
exports["default"] = _default;